module.exports = __webpack_public_path__ + "img/logo2.2e7c928a.png";